<template>
  <div class="flex flex-col items-center bg-white bg-cover bg-center bg-no-repeat"
    style="background-image: url('/images/bg/secBar.png')">
    <div
      class="px-16 py-16 mt-3.5 w-full text-4xl font-semibold text-white whitespace-nowrap max-md:px-5 max-md:max-w-full">
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  name: "SectionBar",
  props: {
    text: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped></style>